module.exports.getDisplayItemList = ( { interests, topicItemsList } ) => {
    // interests: array with selected interests
    // topicItemsList: array with topic => [id],   

    let finalItemList = [];

    const definedTinterests = [
        'social',
        'communication',
        'technology',
        'crafts',
        'entertainment',
        'games',
        'hobbies',
        'travel',
        'health',
        'safety',
        'wellness',
        'courses',
        'spirituality',
        'therapy',
        'volunteer'
    ];

    const mapInterestToTopics = {
        communication: ['communication'],
        courses: ['courses', 'training'],
        crafts: ['crafts'],
        entertainment: ['entertainment', 'music', 'radio', 'tv', 'movies', 'film', 'reading'],
        games: ['games', 'gamee', 'puzzle', 'puzzles'],
        health: ['health', 'healthcare'],   // it was removed from pre-defined interests
        hobbies: ['hobbies', 'craft', 'crafts', 'cooking', 'gardening'],
        safety: ['safety', 'protection', 'legal', 'finance'],   // it was removed from pre-defined interests
        social: ['social', 'engagement'],
        spirituality: ['spirituality'],
        technology: ['technology', 'tech', 'electronic'],
        therapy: ['therapy'],               // it was removed from pre-defined interests
        travel: ['travel', 'vacation'],
        volunteer: ['volunteer'],
        wellness: ['wellness']
    }

    const additionalDefaultTopisForShortList = [
        'communication',
        'social',
        'spirituality'
    ]

    // Build search array
    let topicsForUser = [];
    definedTinterests.forEach((definedInterest) => {
        // if interest contains a topic in definedInterest
        if (interests && interests.includes(definedInterest)) {
            mapInterestToTopics[definedInterest].forEach((topic) => {
                if (!topicsForUser.includes(topic)) {
                    topicsForUser.push(topic)
                }
            });
        }
    });

    // for each topic for user
    topicsForUser.forEach((topicForUser) => {

        // if topicItemsList contains a topic that is the same as topicForUser
        
        // if (topicItemsList.includes(topicForUser)) {
        if (Object.keys(topicItemsList).includes(topicForUser)) {

            topicItemsList[topicForUser].forEach((id) => {
                if (!finalItemList.includes(id)) {
                    finalItemList.push(id);
                }
            });

        }

    });

    // If list is too short, add some more items
    if (finalItemList.length < 6) {

        // for each additional topic for user
        additionalDefaultTopisForShortList.forEach((topicForUser) => {

            // if topicItemsList contains a topic that is the same as topicForUser
            
            // if (topicItemsList.includes(topicForUser)) {
            if (Object.keys(topicItemsList).includes(topicForUser)) {

                topicItemsList[topicForUser].forEach((id) => {
                    if (!finalItemList.includes(id)) {
                        if (finalItemList.length < 15) {
                            finalItemList.push(id);
                        }
                    }
                });

            }

        });
    }

    return finalItemList;
}
